import React from 'react';
import { Box } from '@mui/system';
import { StyledPipaSubProduct } from './styles';

export type IPipaSubProductProps = {
  productImage: string;
  quantityDisplay: string;
  textColor: string;
};

export const PipaSubProduct: React.FC<IPipaSubProductProps> = ({
  textColor,
  productImage,
  quantityDisplay,
}) => {
  return (
    <StyledPipaSubProduct textColor={textColor}>
      <Box className="sub-image">
        <img className="image" src={productImage} alt="coin" />
      </Box>
      {quantityDisplay}
    </StyledPipaSubProduct>
  );
};
